const getToastersData = (state) => state.global.app.toasters;

export const globalState = {
  getToastersData,
};
